import { useQuery } from "@tanstack/react-query";
import { filterOptionsApi } from "../api";
import type { FilterOptionsApiParams } from "../api/types";
import { useClientScope } from "../../../contexts";

export const useDepartments = (options?: {
  withData?: boolean;
  regionIds?: string[];
}) => {
  const { effectiveClientId, isCentralAdmin } = useClientScope();
  const withData = options?.withData;
  const regionIds = options?.regionIds ?? [];
  return useQuery({
    queryKey: [
      "filter-options",
      "departments",
      effectiveClientId,
      withData,
      regionIds,
    ],
    queryFn: () =>
      filterOptionsApi.getDepartments(
        effectiveClientId,
        isCentralAdmin,
        withData,
        regionIds
      ),
    staleTime: 10 * 60 * 1000,
  });
};

export const useRegions = () => {
  const { effectiveClientId } = useClientScope();
  return useQuery({
    queryKey: ["filter-options", "regions", effectiveClientId],
    queryFn: () => filterOptionsApi.getRegions(effectiveClientId),
    staleTime: 10 * 60 * 1000,
  });
};

export const useDepots = () => {
  const { effectiveClientId } = useClientScope();
  return useQuery({
    queryKey: ["filter-options", "depots", effectiveClientId],
    queryFn: () => filterOptionsApi.getDepots(effectiveClientId),
    staleTime: 10 * 60 * 1000,
  });
};

export const useShiftPatterns = () => {
  const { effectiveClientId } = useClientScope();
  return useQuery({
    queryKey: ["filter-options", "shift-patterns", effectiveClientId],
    queryFn: () => filterOptionsApi.getShiftPatterns(effectiveClientId),
    staleTime: 10 * 60 * 1000,
  });
};

export const useAgeRanges = () => {
  const { effectiveClientId } = useClientScope();
  return useQuery({
    queryKey: ["filter-options", "age-ranges", effectiveClientId],
    queryFn: () => filterOptionsApi.getAgeRanges(effectiveClientId),
    staleTime: 10 * 60 * 1000,
  });
};

export const useSexOptions = () => {
  const { effectiveClientId } = useClientScope();
  return useQuery({
    queryKey: ["filter-options", "sex", effectiveClientId],
    queryFn: () => filterOptionsApi.getSexOptions(effectiveClientId),
    staleTime: 10 * 60 * 1000,
  });
};

export const useUsers = (params?: FilterOptionsApiParams) => {
  const { effectiveClientId, isCentralAdmin } = useClientScope();
  return useQuery({
    queryKey: ["filter-options", "users", effectiveClientId, params],
    queryFn: () =>
      filterOptionsApi.getUsers({
        ...params,
        client_id: effectiveClientId,
        bypass_anonymisation:
          params?.bypass_anonymisation ?? isCentralAdmin,
      }),
    enabled: !params?.search || params.search.length >= 2,
    staleTime: 2 * 60 * 1000,
  });
};
